import { useAsyncValue } from 'framework/utils';
import { InputLoader } from 'framework/ui/mui-builder';
import { BaseFilePreviewLayout } from 'domain/shared/artifact/input';
import {
  DocumentFullInfo,
  DocumentIdentifier,
  useCompositeDocumentStorageService,
} from './useCompositeDocumentStorageService';
import { Box } from '@mui/material';

interface CompositeDocumentPreviewListLayoutProps {
  artifactsIdsList: DocumentIdentifier[];
  onRemove: (id: DocumentIdentifier) => void;
  disabled?: boolean;
  isDocumentStorageAvailable?: boolean;
}

const CompositeDocumentPreviewListLayout = ({
  artifactsIdsList,
  onRemove,
  disabled = false,
  isDocumentStorageAvailable,
}: CompositeDocumentPreviewListLayoutProps) => {
  const { getDocumentsInfo, getDocumentThumbnail } = useCompositeDocumentStorageService(isDocumentStorageAvailable);

  const artifactsObjects = useAsyncValue(() => getDocumentsInfo(artifactsIdsList), [artifactsIdsList]);

  if (!artifactsIdsList?.length) {
    return null;
  }

  return artifactsObjects ? (
    artifactsObjects.map((artifactObject: DocumentFullInfo) => (
      <BaseFilePreviewLayout
        key={`${artifactObject.id.storage}-${artifactObject.id.id}`}
        getImageThumbnail={(artifact, cropSize) => getDocumentThumbnail(artifact.id, cropSize)}
        onRemove={() => onRemove(artifactObject.id)}
        artifactObject={artifactObject}
        disabled={disabled}
      />
    ))
  ) : (
    <Box
      position="relative"
      sx={{
        '& i': {
          position: 'absolute',
          fontSize: '14px',
          left: 'calc(50% - 7px)',
          top: 'calc(50% - 7px)',
        },
      }}
    >
      <InputLoader />
    </Box>
  );
};

export default CompositeDocumentPreviewListLayout;
